import { Component, Input, OnInit, ElementRef, ViewChild } from '@angular/core';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzCollapseModule } from 'ng-zorro-antd/collapse';
import { ApiService } from '../../../Services/api.service';
import { CommonModule } from '@angular/common';
import { CategoryAccordionChildComponent } from "../category-accordion-child/category-accordion-child.component";
import { CdkDragMove, DragDropModule } from '@angular/cdk/drag-drop';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { CatalogPreviewComponent } from "../catalog-preview/catalog-preview.component";
import { AddEditCategoryComponent } from "../add-edit-category/add-edit-category.component";
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { SpinnerComponent } from "../../../Common/Components/spinner/spinner.component";
import { ConfirmPopupComponent } from '../../../Common/Components/confirm-popup/confirm-popup.component';
import { cloneDeep } from 'lodash';
import { FormsModule } from '@angular/forms';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { Subject, takeUntil } from 'rxjs';
import { DecodeSpecialCharPipe } from '../../../Common/Components/pipe/DecodeSpecialCharPipe/decode-special-char.pipe';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';

@Component({
  selector: 'app-category-accordion',
  standalone: true,
  imports: [NzInputModule, NzIconModule, NzCollapseModule, NzModalModule, NzButtonModule, ConfirmPopupComponent,
    NzDropDownModule, NzMenuModule, CommonModule, CategoryAccordionChildComponent, DragDropModule,NzToolTipModule,
    CatalogPreviewComponent, AddEditCategoryComponent, NzSpinModule, SpinnerComponent, FormsModule, DecodeSpecialCharPipe],
  templateUrl: './category-accordion.component.html',
  styleUrl: './category-accordion.component.scss'
})
export class CategoryAccordionComponent implements OnInit {
  @Input() catalogId: any;
  @ViewChild(AddEditCategoryComponent) addEditCategoryComp: any;
  constructor(public apiService: ApiService, private elementRef: ElementRef) { }
  categoryData: any;
  categoryDataOriginal: any;
  isSidebarOpen = false;
  selectedSeqId: any = "";
  selectedChildSeqId: any = "";
  categoryLots: any;
  perSeqKey: any = "";
  isLoading: boolean = false;
  showModal: boolean = false;
  modalMessage: string = '';
  modalButton: string = '';
  categoryDetails: any;
  reOrder: boolean = false;
  newCategory: boolean = false;
  searchText: string = '';
  @ViewChild(CdkScrollable) scrollable!: CdkScrollable;
  private destroy$ = new Subject<void>();
 

  ngOnInit(): void {
    this.apiService.activeSelection.selectedSeqId = '';
    console.log(this.apiService.activeSelection.selectedSeqId);
    this.getCategoryTree();
    this.apiService.action$
      .pipe(takeUntil(this.destroy$)) // Listens until destroy$ emits
      .subscribe(action => {
        if (action.type == 'duplicate' || action.type == 'delete') {
          this.refreshCategoryTree('reset');
        }
      });
  }

  ngOnChanges() {
  }

  refreshCategoryTree(event: any) {
    if (event == 'reset') {
      this.selectedSeqId = '';
    }
    this.getCategoryTree()
  }

  getCategoryTree() {
    this.isLoading = true;
    this.apiService.getCatalogTreeById(this.catalogId).subscribe(
      response => {
        this.isLoading = false;
        this.categoryDataOriginal = cloneDeep(response);
        this.categoryData = response;

        if (Array.isArray(this.categoryData)) {
          this.categoryData.forEach((node: any) => {
            this.initializeTreeProperties(node);
          });
        }
      },
      err => {
        this.isLoading = false;
        this.apiService.createNotification('error', err?.error?.message || 'Failed to load category tree');
      }
    );
  }


  initializeTreeProperties(node: any): void {

    Object.assign(node, {
      isOpen: false,
      renderChild: false,
      isMenuOpen: false,
      isPreviewOpen: false,
      hovered: false
    });


    if (node.categories && Array.isArray(node.categories)) {
      node.categories.forEach((childNode: any) => this.initializeTreeProperties(childNode));
    }
  }

  filterTree(nodes: any, term: string): any {

    if (!term || !term.trim()) {
      return nodes.map((node: any) => {

        node.renderChild = false;
        return node;
      });
    }

    const normalizedTerm = term.toLowerCase();

    return nodes
      .map((node: any) => {
        const match =
          (node?.categoryname && node.categoryname.toLowerCase().includes(normalizedTerm)) ||
         (node?.lots?.some((lot: any) => lot.lotId?.toLowerCase().includes(normalizedTerm))) ||
          (node?.styleid && node.styleid.toLowerCase().includes(normalizedTerm)) ||
          (node?.version && node.version.toLowerCase().includes(normalizedTerm));
        const categories = node.categories ? this.filterTree(node.categories, term) : [];

        if (match || categories.length) {

          Object.assign(node, {
            isOpen: true,
            renderChild: true,
            isMenuOpen: false,
            isPreviewOpen: false
          });

          return { ...node, categories };
        }
        return null;
      })
      .filter((node: any) => node !== null);
  }

  filterCategoryData(searchTerm: any): void {
    searchTerm = searchTerm.trim();
    this.searchText.trim();
    let data = cloneDeep(this.categoryDataOriginal);
    this.categoryData = this.filterTree(data, searchTerm);
  }

  getMDClass() {
    return this.categoryDataOriginal?.length > 0 ? 'col-md-7' : 'col-md-12';
  }

  onPanelClose(state: boolean, childNode: any, parentList: any, index: number): void {

    this.addIsOpenProperty(parentList[index], false,childNode["seqno"]);
    childNode.hovered = false;
    childNode.isMenuOpen = false;
    childNode.isOpen = state;


    if (state) {

      setTimeout(() => {
        childNode.renderChild = true;


      }, 150);
    } else {

      childNode.renderChild = false;
    }
  }


  drop(event: CdkDragDrop<any[]>, parentCategory: any) {
    moveItemInArray(parentCategory, event.previousIndex, event.currentIndex);
  }

  onChildDrop(event: CdkDragDrop<any[]>, parentCategory: any) {
    this.drop(event, parentCategory); // reuse logic
  }

  trackByCategoryId(index: number, category: any): number {
    return category['catalogid'];  // Or any unique identifier
  }


  addIsOpenProperty(node: any, isOpenValue: boolean,excludeSeqId?: any) {
    node.isOpen = isOpenValue;
    node.hovered = false;
    node.isMenuOpen = false;
    node.isPreviewOpen = false;


    if (!isOpenValue) {
      node.renderChild = false;
    }

    //  if (node["seqno"] !== excludeSeqId) {
    //     if (this.apiService.activeSelection.selectedSeqId == node["seqno"]) {
    //       this.apiService.activeSelection.selectedSeqId = '';
    //     }
    //   }

    if (node.categories && Array.isArray(node.categories)) {
      node.categories.forEach((childNode: any) => this.addIsOpenProperty(childNode, isOpenValue));
    }
  }
  onMenuLeave(category: any) {
    category['isHovered'] = false;
    category['isMenuOpen'] = false;
    category['hovered'] = false;
  }

  addIsMenuOpenProperty(node: any, isOpenValue: boolean) {

    if (Array.isArray(node)) {
      node.forEach((childNode: any) => this.addIsMenuOpenProperty(childNode, isOpenValue));
    }

    else if (node) {
      node.isMenuOpen = isOpenValue;
      node.hovered = isOpenValue;


      if (node.categories && Array.isArray(node.categories)) {
        node.categories.forEach((childNode: any) => this.addIsMenuOpenProperty(childNode, isOpenValue));
      }
    }
  }

  handleHover(category: any, parentList: any, state: boolean) {
    if (state === true) {

      this.addIsMenuOpenProperty(parentList, false);
      category.hovered = true;
    } else {

      category.hovered = !!category.isMenuOpen;
    }
  }

 loadCategory(category: any) {
  if (!category) return;
  this.apiService.activeSelection.selectedSeqId = category["seqno"];
  this.selectedSeqId = category["seqno"];
  this.newCategory = false;
}

loadChildCategory(category: any) {
  if (!category) return;
  this.apiService.activeSelection.selectedSeqId = category["seqno"];
  this.selectedSeqId = category["seqno"];
  this.newCategory = false;
  if (category["lots"]) {
    this.categoryLots = category["lots"];
  }
}

  onDragMove(event: CdkDragMove): void {
    if (!this.scrollable) return;

    const container = this.scrollable.getElementRef().nativeElement;
    const rect = container.getBoundingClientRect();
    const { y } = event.pointerPosition;
    const scrollSpeed = 15;
    const edgeThreshold = 50;

    if (y < rect.top + edgeThreshold) {
      container.scrollTop -= scrollSpeed;
    } else if (y > rect.bottom - edgeThreshold) {
      container.scrollTop += scrollSpeed;
    }
  }

  resetSelection() {
    this.selectedSeqId = '';
    this.apiService.activeSelection.selectedSeqId = '';
    this.searchText = '';
    let catagoryDataBackup = cloneDeep(this.categoryDataOriginal);
    this.categoryData = [...catagoryDataBackup];
  }

  duplicateCategory(catDetails: any) {
    this.modalMessage = 'Are you sure you want to duplicate selected Category?';
    this.modalButton = 'Duplicate';
    this.showModal = true;;
    this.categoryDetails = catDetails;

  }

  deleteCategory(catDetails: any) {
    this.modalMessage = 'Are you sure you want to delete selected Category?';
    this.modalButton = 'Delete';
    this.showModal = true;
    this.categoryDetails = catDetails;
  }

  onConfirm() {
    this.showModal = false;
    if (this.modalButton == 'Delete') {
      this.apiService.deleteCategory(this.categoryDetails.seqno).subscribe(res => {
        this.categoryDetails = {};
        this.getCategoryTree();
        this.apiService.createNotification('success', res?.message);
      }, (error: any) => {
        this.apiService.createNotification('error', error?.error.message);
      })
    }

    if (this.modalButton == 'Duplicate') {
      this.apiService.duplicateCategory(this.catalogId, this.categoryDetails.seqno).subscribe(res => {
        this.categoryDetails = {};
        this.getCategoryTree();
        this.apiService.createNotification('success', res?.message);
      }, (error: any) => {
        this.apiService.createNotification('error', error?.error.message);
      })
    }
  }

  saveReorder() {
    this.isLoading = true;
    this.apiService.updateCategorySequence(this.categoryData).subscribe(res => {
      this.reOrder = false;
      this.getCategoryTree();
      this.apiService.createNotification('success', res?.message);
    }, (error: any) => {
      this.isLoading = true;
      this.apiService.createNotification('error', error?.error.message);
    })
  }


  updateLots(lots: any[]) {

    if (!Array.isArray(this.categoryData)) return;

    const categoryDataOriginal = [...this.categoryData];


    while (categoryDataOriginal.length > 0) {

      const cat = categoryDataOriginal.pop();
      if (cat.lastcat == 1 && this.selectedSeqId == cat.seqno) {
        cat.lots = lots;
        break;
      }

      if (Array.isArray(cat.categories) && cat.categories.length) {
        categoryDataOriginal.push(...cat.categories);
      }

    }
  }

  intiateNewCategory() {
    this.newCategory = !this.newCategory;
    this.addEditCategoryComp.showAddCategoryForm = true;
    this.selectedSeqId = '';
  }

  ngOnDestroy() {
    this.destroy$.next(); // Trigger the "stop" signal
    this.destroy$.complete();
  }

}

